import React from 'react';

type Props = {
  url: string;
};

const styles = {
  wrapper: 'mask mask-squircle',
  container: 'mask mask-squircle discover-avatar',
};

export default function AltAvatar({ url }: Props) {
  const bgImageStyle = {
    backgroundImage: `url(${url})`,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    overflow: 'hidden',
  };
  return <div className={styles.container} style={bgImageStyle} />;
}
